export enum AddressType {
    DOMICILE_ADDRESS = 11,
    COMPANY_ADDRESS = 15,
}

export interface IAddress {
    addressType: AddressType | number;
    validAfter: string; // "YYYY-MM-DD
    validUntil: string; // "YYYY-MM-DD
    street: string;
    houseNumber?: string;
    place: string;
    postcode: string;
    region: number;
    canton: string;
    country: string;
    vatCountry: string;
    correspondenceLanguageMan: string;
    correspondenceLanguageSys: string;
    dispatchType: string;
    noAdvertising: boolean;
    coAddressFlag: boolean;
    correspondenceRule: boolean;
    invalid: boolean;
}
